import { render, staticRenderFns } from "./ProductCostContainer.vue?vue&type=template&id=c9fc020a&scoped=true"
import script from "./ProductCostContainer.vue?vue&type=script&lang=js"
export * from "./ProductCostContainer.vue?vue&type=script&lang=js"
import "./ProductCostContainer.vue?vue&type=style&index=0&id=c9fc020a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fc020a",
  null
  
)

export default component.exports